"use strict";

import angular from "angular";

import _ from "lodash";
import { Accounting } from "../../../../../gateway/Accounting/Accounting";
import { Events } from "../../../../../presentation/services/Events/Events";
import toastCustomTemplate from "../../../../components/nu-toast-custom/toast-custom.component.html";

export class UpgradeContractCtrl {
    constructor($mdDialog, DSNDialogService, locals, $stateParams, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.accounting = locals.accounting || null;
        this.toast = toast;

        this.accountingId = _.get($stateParams, "accountingId");

        this.currentPlan = "";
        this.switchContract = "";
        this.countCompany = 0;

        this.Accounting = new Accounting();
        this.Events = new Events();

        this.listContract = [];
    }

    $onInit() {
        this._setListContract();
        this.currentContract = _.get(this.accounting, "contract");
        this.switchContract = this.currentContract;
    }

    _setListContract() {
        this.listContract = [
            {
                title: "Starter",
                value: "Starter",
                disabled: [
                    "Expert",
                    "Standard",
                    "Starter",
                    "Professioanl"
                ].includes(this.accounting.contract)
                    ? true
                    : false,
                showByContract: "none",
                benefits: [
                    {
                        text: "Carteira Consultiva;",
                        strong: false
                    },
                    {
                        text: "Prospect e Nucontent;",
                        strong: false
                    },
                    {
                        text: "Análise e entregas do financeiro, pessoal e fiscal;",
                        strong: false
                    },
                    {
                        text: "Auditoria e saúde do financeiro, pessoal e fiscal;",
                        strong: false
                    },
                    {
                        text: "Importação fiscal via PGDAS;",
                        strong: false
                    },
                    {
                        text: "Avaliação NPS;",
                        strong: false
                    },
                    {
                        text: "Nucont Score;",
                        strong: false
                    }
                ]
            },

            {
                title: "Professional",
                value: "Professional",
                showByContract: "none",
                disabled: ["Expert", "Standard", "Professional"].includes(
                    this.accounting.contract
                )
                    ? true
                    : false,
                benefits: [
                    {
                        text: "Todas funcionalidades do Starter;",
                        strong: true
                    },

                    {
                        text: "Análise e entrega do contábil;",
                        strong: false
                    },

                    {
                        text: "Auditoria e saúde do contábil",
                        strong: false
                    },
                    {
                        text: "Customização de Dashboards e Indicadores dos financeiro, pessoal e fiscal;",
                        strong: false
                    }
                ]
            },
            {
                title: "Standard",
                value: "Standard",
                tooltip:
                    "O Plano Standard não será mais comercializado e não terá mais atualizações. Sugerimos escolher um dos novos planos disponíveis.",
                disabled: true,
                showByContract: "Standard",
                benefits: [
                    {
                        text: "Carteira Consultiva;",
                        strong: false
                    },
                    {
                        text: "Prospect e Nucontent;",
                        strong: false
                    },
                    {
                        text: "Análise e Auditoria dos 4 módulos;",
                        strong: false
                    },
                    {
                        text: "Customização de dashboards, indicadores e gráficos;",
                        strong: false
                    },
                    {
                        text: "*Esse plano não será mais comercializado, portando não recebe atualizações. Sugerimos a escolha de um novo plano disponível.",
                        strong: false
                    }
                ]
            },
            {
                title: "Expert",
                value: "Expert",
                showByContract: "none",
                disabled: false,
                benefits: [
                    {
                        text: "Todas funcionalidades do Professional;",
                        strong: true
                    },
                    {
                        text: "Análise em grupo;",
                        strong: false
                    },
                    {
                        text: "Paleta de Cores no Dashboard;",
                        strong: false
                    },
                    {
                        text: "Customização de Dashboards e Indicadores do contábil, financeiro, pessoal e fiscal;",
                        strong: false
                    }
                ]
            }
        ];
    }

    onVerifyCountCompany() {
        if (isNaN(this.countCompany || this.countCompany <= 0))
            this.countCompany = 0;
    }
    onCountCompany(type) {
        if (this.countCompany <= 0 || isNaN(this.countCompany))
            this.countCompany = 0;
        if (type === "+") this.countCompany += 5;
        else if (type === "-")
            this.countCompany =
                this.countCompany <= 0 ? 0 : (this.countCompany -= 5);
        if (this.countCompany < 5 && type === "-") this.countCompany = 0;
    }

    async submitUpgrade() {
        this.loading = true;
        this.Events.send("Solicitacao.Grow");

        await this.Accounting.submitUpgrade({
            accountingId: this.accountingId,
            contract: {
                current: this.currentContract,
                new: this.switchContract
            },
            companies: {
                current: _.get(this.accounting, "plan.countCompany"),
                new: this.countCompany
            }
        });

        this.loading = false;
        this._successToast();
        this.$mdDialog.hide();
    }

    _successToast() {
        this.toast.show("", "bottom right", {
            hideDelay: 5000,
            controllerAs: "ctrl",
            locals: {
                toastMessage:
                    "Solicitação enviada, em breve entraremos em contato.",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }
}

angular
    .module("nucont.shared")
    .controller("UpgradeContractCtrl", [
        "$mdDialog",
        "DSNDialogService",
        "locals",
        "$stateParams",
        "toast",
        UpgradeContractCtrl
    ]);
